export default [
  {
    time: '09:30-09:35',
    title: '主持人开场'
  },
  {
    time: '09:35-09:40',
    title: '主办方致辞',
    guests: [
      {
        name: '何强',
        position: '每日经济新闻执行总编辑'
      }
    ]
  },
  {
    time: '09:40-09:55',
    title: '主旨演讲一<br>政策新思维，市场新机会',
    guests: [
      {
        name: '张智威',
        position: '保银投资总裁、首席经济学家'
      }
    ]
  },
  {
    time: '09:55-10:10',
    title: ' 主旨演讲二<br>共同富裕大潮下的投资展望',
    guests: [
      {
        name: '方磊',
        position: '星石投资副总经理、高级基金经理、首席研究官'
      }
    ]
  },
  {
    time: '10:10-10:25',
    title: '主旨演讲三<br>不确定的市场，如何寻找确定性的投资机会，定增和量化相结合的优势策略',
    guests: [
      {
        name: '蒋晓飞',
        position: '大岩资本创始合伙人、基本面投研主管'
      }
    ]
  },
  {
    time: '10:25-10:40',
    title: '主旨演讲四<br>择时择优，顺势而为，场外期权衍生品投资策略的应用',
    guests: [
      {
        name: '牛晓涛',
        position: '宁波乔格理投资管理有限公司董事长兼投资总监'
      }
    ]
  },
  {
    time: '10:40-11:20',
    title: '圆桌对话<br>财富管理大时代来临，私募基金面临的机遇与挑战',
    guests: [
      {
        name: '主持人 ——'
      },
      {
        name: '舒泰峰',
        position: '重阳投资合伙人'
      },
      {
        name: '嘉宾 ——'
      },
      {
        name: '吴伟志',
        position: '中欧瑞博董事长兼投资总监'
      },
      {
        name: '韩海峰',
        position: '高毅资产合伙人、研究总监'
      },
      {
        name: '周奇伟',
        position: '盈峰资本投资研究部总监'
      },
      {
        name: '刘志超',
        position: '趣时资产投资副总监'
      },
      {
        name: '李宇龙',
        position: '友山基金副总裁'
      }
    ]
  },

  {
    time: '11:20-11:30',
    title: '2021中国金鼎奖（私募）颁奖典礼',
    subTitle: ' '
  }
];
